import { useLanguage } from "../lib/useLanguage";

export default function LanguageToggle({ className = "" }) {
  const { lang, setLang } = useLanguage();
  return (
    <button
      onClick={() => setLang(lang === "fr" ? "en" : "fr")}
      className={`flex items-center gap-0.5 px-2.5 py-1 rounded-full text-xs font-bold border transition-all ${className}`}
      style={{ borderColor: "#FF6B4A", color: "#FF6B4A" }}
    >
      <span style={{ opacity: lang === "fr" ? 1 : 0.4 }}>FR</span>
      <span className="opacity-30 mx-0.5">/</span>
      <span style={{ opacity: lang === "en" ? 1 : 0.4 }}>EN</span>
    </button>
  );
}